import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class ErrorService {

  errorMessage: string = '';
  

  constructor(
    private router: Router) { }

  alertError(error : any): string {
    if (error instanceof HttpErrorResponse) {
      this.errorMessage = `Error: ${error.error.message}`;      
    } else {
      this.errorMessage = `Error: ${error.message}`;
    }
    if (this.errorMessage.includes('expired') || this.errorMessage.includes('Unauthorised') || this.errorMessage.includes('Invalid Access Token')) {
      this.errorMessage = this.errorMessage + ', Please login again.';
      alert(this.errorMessage);
      this.router.navigate(['/login']);
    }
    else {
      alert(this.errorMessage);
    }
    return this.errorMessage;
  }
}
